// import React, { useState, useEffect, useRef } from "react";
// import { toastr } from "react-redux-toastr";
// import { connect } from "react-redux";
// import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
// import { useParams, useNavigate } from "react-router-dom";
// import debounce from 'lodash/debounce';
// import { DragDropContext } from 'react-beautiful-dnd';
// import WarehouseAssortmentDetailsComponent from "./component";
// import CohortAssortmentDetailsComponent from "./component";

// const CohortAssortmentDetailsContainer = (props) => {
//   const navigate = useNavigate();
//   const { reference_id, assortmentId } = useParams();
//   const [assortmentDetails, setAssortmentDetails] = useState([]);
//   const [activeTabIndex, setActiveTabIndex] = useState(0);
//   const [autoScrollDirection, setAutoScrollDirection] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [modifiedItems, setModifiedItems] = useState(null);
//   const [hasChanges, setHasChanges] = useState(false);
//   const itemsContainerRef = useRef(null);
//   const scrollIntervalRef = useRef(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   useEffect(() => {
//     handleAssortmentDetails();
//     return () => {
//       if (scrollIntervalRef.current) {
//         clearInterval(scrollIntervalRef.current);
//       }
//     };
//   }, []);

//   const handleAssortmentDetails = debounce((query = "") => {
//     setLoading(true);
//     props.getDataFromAPI(
//       `/partner/api/v1/assortment/${assortmentId}`,
//       "GET",
//       undefined,
//       (response) => {
//         // Ensure all required arrays exist
//         const data = response || response;
//         const enhancedData = {
//           ...data,
//           priority_wise_items: data.priority_wise_items || [],
//           rule_failures: data.rule_failures || [],
//           hardware_type_items: data.hardware_type_items || [],
//           created_by_name: data.created_by_name || 'N/A',
//           status: data.status || 'N/A'
//         };
//         setAssortmentDetails(enhancedData);
//         setModifiedItems(null);
//         setHasChanges(false);
//         setLoading(false);
//       },
//       (err) => {
//         console.error("API Error:", err);
//         setLoading(false);
//         toastr.error("Failed to load assortment details", err.message);
//       }
//     );
//   }, 300);

//   const saveNewOrder = () => {
//     if (!modifiedItems) return;

//     const payload = {
//       start_date: assortmentDetails.start_date,
//       priority_wise_items: modifiedItems[activeTabIndex].map(item => ({ mv_id: item.mv_id }))
//     };

//     setLoading(true);
//     props.getDataFromAPI(
//       `/partner/api/v1/assortment/${assortmentId}/update`,
//       "PATCH",
//       payload,
//       (response) => {
//         toastr.success("Assortment updated successfully");
//         const updatedDetails = { ...assortmentDetails };
//         if (updatedDetails.hardware_type_items?.[activeTabIndex]) {
//           updatedDetails.hardware_type_items[activeTabIndex].priority_wise_items = modifiedItems[activeTabIndex];
//         } else {
//           updatedDetails.priority_wise_items = modifiedItems[activeTabIndex];
//         }
//         setAssortmentDetails(updatedDetails);
//         setHasChanges(false);
//         setLoading(false);
//       },
//       (err) => {
//         console.error("API Error:", err);
//         toastr.error(err.message);
//         setLoading(false);
//         handleAssortmentDetails();
//       }
//     );
//   };

//   const handleChangeHardwareTypePriority = () => {
//     if (!modifiedItems) return;

//     const payload = {
//       start_date: assortmentDetails.start_date,
//       priority_wise_items: modifiedItems[activeTabIndex].map(item => ({ mv_id: item.mv_id }))
//     };

//     setLoading(true);
//     props.getDataFromAPI(
//       `/partner/api/v1/assortment/${assortmentId}/update`,
//       "PATCH",
//       payload,
//       (response) => {
//         toastr.success("Assortment updated successfully");
//         const updatedDetails = { ...assortmentDetails };
//         if (updatedDetails.hardware_type_items?.[activeTabIndex]) {
//           updatedDetails.hardware_type_items[activeTabIndex].priority_wise_items = modifiedItems[activeTabIndex];
//         } else {
//           updatedDetails.priority_wise_items = modifiedItems[activeTabIndex];
//         }
//         setAssortmentDetails(updatedDetails);
//         setHasChanges(false);
//         setLoading(false);
//       },
//       (err) => {
//         console.error("API Error:", err);
//         toastr.error(err.message);
//         setLoading(false);
//         handleAssortmentDetails();
//       }
//     );
//   };

//   const handleDragEnd = (result) => {
//     stopAutoScroll();
    
//     if (!result.destination) return;

//     const sourceIndex = result.source.index;
//     const destIndex = result.destination.index;
    
//     if (sourceIndex === destIndex) return;

//     let currentItems = [];
//     if (assortmentDetails?.hardware_type_items?.[activeTabIndex]) {
//       currentItems = [...assortmentDetails.hardware_type_items[activeTabIndex].priority_wise_items];
//     } else if (assortmentDetails?.priority_wise_items) {
//       currentItems = [...assortmentDetails.priority_wise_items];
//     }

//     const newItems = Array.from(currentItems);
//     const [removed] = newItems.splice(sourceIndex, 1);
    
//     removed.originalIndex = sourceIndex;
//     newItems.splice(destIndex, 0, removed);

//     const updatedModifiedItems = modifiedItems || {};
//     updatedModifiedItems[activeTabIndex] = newItems.map((item, idx) => ({
//       ...item,
//       originalIndex: item.originalIndex !== undefined ? item.originalIndex : idx
//     }));
    
//     setModifiedItems(updatedModifiedItems);
//     setHasChanges(true);
//   };

//   const handleTabChange = (index) => {
//     if (hasChanges) {
//       if (window.confirm("You have unsaved changes. Do you want to discard them?")) {
//         setActiveTabIndex(index);
//         setHasChanges(false);
//         setModifiedItems(null);
//       }
//     } else {
//       setActiveTabIndex(index);
//     }
//   };

//   const handleCancelChanges = () => {
//     setModifiedItems(null);
//     setHasChanges(false);
//   };

//   const startAutoScroll = (direction) => {
//     if (scrollIntervalRef.current) return;
    
//     const scrollStep = direction === 'up' ? -10 : 10;
//     scrollIntervalRef.current = setInterval(() => {
//       if (itemsContainerRef.current) {
//         itemsContainerRef.current.scrollBy(0, scrollStep);
//       }
//     }, 16);
//   };

//   const stopAutoScroll = () => {
//     if (scrollIntervalRef.current) {
//       clearInterval(scrollIntervalRef.current);
//       scrollIntervalRef.current = null;
//     }
//     setAutoScrollDirection(null);
//   };

//   const handleDragUpdate = (update) => {
//     if (!itemsContainerRef.current || !update.destination) {
//       stopAutoScroll();
//       return;
//     }
    
//     const container = itemsContainerRef.current;
//     const { top, bottom, height } = container.getBoundingClientRect();
//     const { clientY } = update.destination;
//     const buffer = height * 0.2;
    
//     if (clientY < top + buffer) {
//       if (autoScrollDirection !== 'up') {
//         stopAutoScroll();
//         setAutoScrollDirection('up');
//         startAutoScroll('up');
//       }
//     } else if (clientY > bottom - buffer) {
//       if (autoScrollDirection !== 'down') {
//         stopAutoScroll();
//         setAutoScrollDirection('down');
//         startAutoScroll('down');
//       }
//     } else {
//       stopAutoScroll();
//     }
//   };

//   const handleEndAssortment = () => {
//     setLoading(true);
//     props.getDataFromAPI(
//       `/partner/api/v1/assortment/${assortmentId}/inactive`,
//       "PUT",
//       undefined, 
//       (response) => {
//         toastr.success("Assortment inactive successfully");
//         setLoading(false);
//         setShowDeleteModal(false);
//       },
//       (err) => {
//         console.error("API Error:", err);
//         toastr.error(err.message || "Something went wrong");
//         setLoading(false);
//         setShowDeleteModal(false);
//       }
//     );
//   };

//   return (
//     <DragDropContext 
//       onDragEnd={handleDragEnd}
//       onDragUpdate={handleDragUpdate}
//     >
//       <CohortAssortmentDetailsComponent
//         assortmentDetails={assortmentDetails}
//         loading={loading}
//         activeTabIndex={activeTabIndex}
//         onTabChange={handleTabChange}
//         itemsContainerRef={itemsContainerRef}
//         autoScrollDirection={autoScrollDirection}
//         hasChanges={hasChanges}
//         onSaveChanges={saveNewOrder}
//         onCancelChanges={handleCancelChanges}
//         modifiedItems={modifiedItems}
//         handleEndAssortment={handleEndAssortment}
//         setShowDeleteModal={setShowDeleteModal}
//         showDeleteModal={showDeleteModal}
//       />
//     </DragDropContext>
//   );
// };

// function mapStateToProps(props) {
//   return {
//     props,
//   };
// }

// export default connect(mapStateToProps, {
//   getDataFromAPI,
// })(CohortAssortmentDetailsContainer);
import React, { useState, useEffect, useRef } from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useParams, useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';
import WarehouseAssortmentDetailsComponent from "./component";

const CohortAssortmentDetailsContainer = (props) => {
  const navigate = useNavigate();
  const { assortmentId } = useParams();
  const [assortmentDetails, setAssortmentDetails] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [modifiedPrimaryItems, setModifiedPrimaryItems] = useState({});
  const [modifiedSecondaryItems, setModifiedSecondaryItems] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [categories, setCategories] = useState(['All']);
  const [loadedHardwareTypes, setLoadedHardwareTypes] = useState(new Set());
  const [assortmentSlotDetails, setAssortmentSlotDetails] = useState();
  const [autoScrollDirection, setAutoScrollDirection] = useState(null);
  const [checkRule, setCheckRule] = useState()

  const itemsContainerRef = useRef(null);
  const scrollIntervalRef = useRef(null);

  useEffect(() => {
    handleAssortmentDetails();
    return () => {
      if (scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
      }
    };
  }, []);

  const handleAssortmentDetails = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/${assortmentId}`,
      "GET",
      undefined,
      (response) => {
        setAssortmentDetails(response);
        extractCategories(response);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error(err.message);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentSlotDetails = (hardwareTypeId) => {
    if (!hardwareTypeId) return;

    props.getDataFromAPI(
      `/partner/api/v1/assortment/hardwareType/${hardwareTypeId}/slot/detail`,
      "GET",
      undefined,
      (response) => {
       
        setAssortmentSlotDetails(response || []);
      },
      (err) => {
        console.error("API Error:", err);
        setAssortmentSlotDetails([]); // Set empty array on error
      }
    );
  };

  const extractCategories = (data) => {
    const allCategories = new Set();

    data.priority_wise_items?.forEach(item => {
      item.categories?.forEach(cat => allCategories.add(cat));
    });

    data.hardware_type_items?.forEach(hardware => {
      hardware.priority_wise_items?.forEach(item => {
        item.categories?.forEach(cat => allCategories.add(cat));
      });
      hardware.remaining_assortment_items?.forEach(item => {
        item.categories?.forEach(cat => allCategories.add(cat));
      });
    });

    const categoriesArray = Array.from(allCategories).sort();
    setCategories(['All', ...categoriesArray]);
  };

  const processItemsWithRanks = (items, startRank = 1) => {
    return items.map((item, index) => ({
      ...item,
      rank: startRank + index,
      originalRank: startRank + index,
      hasRankChanged: false
    }));
  };

  const handleTabChange = (index) => {
    if (hasChanges) {
      if (window.confirm("You have unsaved changes. Do you want to discard them?")) {
        changeTab(index);
        setHasChanges(false);
        setModifiedPrimaryItems({});
        setModifiedSecondaryItems({});
      }
    } else {
      changeTab(index);
    }
  };

  const changeTab = (index) => {
    setActiveTabIndex(index);

    if (index > 0 && !loadedHardwareTypes.has(index)) {
      const hardwareTypeId = assortmentDetails.hardware_type_items?.[index - 1]?.hardware_type_id;
      if (hardwareTypeId) {
        handleAssortmentSlotDetails(hardwareTypeId);
      }
      setLoadedHardwareTypes(prev => new Set(prev).add(index));
    }
  };

  const filterItemsByCategory = (items) => {
    if (!items) return [];
    if (selectedCategory === 'All') return items;
    return items.filter(item => item.categories?.includes(selectedCategory));
  };

  const getCurrentItems = () => {
    let items = modifiedPrimaryItems[activeTabIndex];
    if (!items) {
      if (activeTabIndex === 0) {
        items = assortmentDetails.priority_wise_items || [];
      } else {
        const hardwareIndex = activeTabIndex - 1;
        items = assortmentDetails?.hardware_type_items?.[hardwareIndex]?.priority_wise_items || [];
      }
      items = processItemsWithRanks(items);
    }
    return filterItemsByCategory(items);
  };

  const getRemainingItems = () => {
    if (activeTabIndex === 0) return [];
    let items = modifiedSecondaryItems[activeTabIndex];
    if (!items) {
      const hardwareIndex = activeTabIndex - 1;
      items = assortmentDetails.hardware_type_items?.[hardwareIndex]?.remaining_assortment_items || [];
      items = processItemsWithRanks(items, getCurrentItems().length + 1);
    }
    return filterItemsByCategory(items);
  };
  const getSlotDetailsForItem = (item) => {
    if (activeTabIndex === 0) return null;
    const hardwareTypeId = assortmentDetails.hardware_type_items?.[activeTabIndex - 1]?.hardware_type_id;
    if (!hardwareTypeId) return null;

    const slots = assortmentSlotDetails[hardwareTypeId];
    if (!slots) return null;


    return slots.find(slot => {
      console.log("Comparing:", {
        slotId: slot.slotId,
        itemSlotId: item.slotId,
        slot,
        item
      });
      return slot.slotId === item.slotId;
    });
  };

  const handleItemDrop = (droppedItem, targetIndex, sourceType) => {
    const currentPrimary = [...getCurrentItems()];
    const currentSecondary = [...getRemainingItems()];

    let newPrimary = [...currentPrimary];
    let newSecondary = [...currentSecondary];

    if (sourceType === 'primary') {
      // Reordering within primary list
      const sourceIndex = newPrimary.findIndex(item => item.mv_id === droppedItem.mv_id);
      if (sourceIndex === -1 || sourceIndex === targetIndex) return;

      const [movedItem] = newPrimary.splice(sourceIndex, 1);
      newPrimary.splice(targetIndex, 0, movedItem);

      // Update ranks and mark only the moved item as changed
      newPrimary = newPrimary.map((item, index) => ({
        ...item,
        rank: index + 1,
        hasRankChanged: item.mv_id === droppedItem.mv_id ? item.originalRank !== index + 1 : false
      }));
    } else {
      // Moving from secondary to primary - swap with target item in primary
      const sourceIndex = newSecondary.findIndex(item => item.mv_id === droppedItem.mv_id);
      if (sourceIndex === -1 || targetIndex >= newPrimary.length) return;

      const targetItem = newPrimary[targetIndex];
      const [movedItem] = newSecondary.splice(sourceIndex, 1);

      // Swap the items
      newPrimary[targetIndex] = {
        ...movedItem,
        rank: targetIndex + 1,
        hasRankChanged: true,
        originalRank: movedItem.originalRank
      };

      // Add the target item to secondary
      newSecondary.splice(sourceIndex, 0, {
        ...targetItem,
        rank: currentPrimary.length + sourceIndex + 1,
        hasRankChanged: true,
        originalRank: targetItem.rank
      });

      // Update ranks for secondary items
      newSecondary = newSecondary.map((item, index) => ({
        ...item,
        rank: currentPrimary.length + index + 1,
        hasRankChanged: item.hasRankChanged // Preserve existing changes
      }));
    }

    setModifiedPrimaryItems(prev => ({
      ...prev,
      [activeTabIndex]: newPrimary
    }));

    if (activeTabIndex > 0) {
      setModifiedSecondaryItems(prev => ({
        ...prev,
        [activeTabIndex]: newSecondary
      }));
    }

    setHasChanges(true);
  };

  const handleSaveChanges = () => {
    if (activeTabIndex === 0) {
      savePrimaryAssortment();
    } else {
      saveHardwareTypeAssortment();
    }
  };

  const savePrimaryAssortment = () => {
    const primaryItems = modifiedPrimaryItems[activeTabIndex];
    if (!primaryItems) return;

    const payload = {
      start_date: assortmentDetails.start_date,
      priority_wise_items: primaryItems.map(item => ({ mv_id: item.mv_id }))
    };

    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/${assortmentId}/update`,
      "PATCH",
      payload,
      (response) => {
        toastr.success("Primary assortment updated successfully");
        const updatedDetails = { ...assortmentDetails };
        updatedDetails.priority_wise_items = primaryItems.map(item => ({
          ...item,
          originalRank: item.rank,
          hasRankChanged: false
        }));
        setAssortmentDetails(updatedDetails);
        setHasChanges(false);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error(err.message);
        setLoading(false);
      }
    );
  };

  const saveHardwareTypeAssortment = () => {
    const hardwareTypeId = assortmentDetails.hardware_type_items?.[activeTabIndex - 1]?.hardware_type_id;
    if (!hardwareTypeId) return;

    const priorityItems = modifiedPrimaryItems[activeTabIndex]?.map(item => ({ mv_id: item.mv_id })) || [];
    const remainingItems = modifiedSecondaryItems[activeTabIndex]?.map(item => ({ mv_id: item.mv_id })) || [];
    const mergedPayload = [...priorityItems, ...remainingItems];

    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/${assortmentId}/hardwareType/${hardwareTypeId}/update`,
      "PUT",
      mergedPayload,
      (response) => {
        toastr.success("Hardware type assortment updated successfully");
        const updatedDetails = { ...assortmentDetails };
        const hardwareIndex = activeTabIndex - 1;

        updatedDetails.hardware_type_items[hardwareIndex].priority_wise_items =
          modifiedPrimaryItems[activeTabIndex].map(item => ({
            ...item,
            originalRank: item.rank,
            hasRankChanged: false
          }));

        updatedDetails.hardware_type_items[hardwareIndex].remaining_assortment_items =
          (modifiedSecondaryItems[activeTabIndex] || []).map(item => ({
            ...item,
            originalRank: item.rank,
            hasRankChanged: false
          }));

        setAssortmentDetails(updatedDetails);
        setHasChanges(false);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error(err.message || "Failed to update hardware type assortment");
        setLoading(false);
      }
    );
  };

const handleCheckRule = debounce(() => {
  setLoading(true);
  props.getDataFromAPI(
    `/partner/api/v1/assortment/${assortmentId}/rule/check`,
    "GET",
    undefined,
    (response) => {
      setAssortmentDetails((prev) => ({
        ...prev,
        rule_failures: response || []
      }));
      toastr.success("Rules rechecked successfully");
      setLoading(false);
    },
    (err) => {
      console.error("API Error:", err);
      toastr.error(err.message);
      setLoading(false);
    }
  );
}, 300);





  const handleCancelChanges = () => {
    setModifiedPrimaryItems({});
    setModifiedSecondaryItems({});
    setHasChanges(false);
  };

  const handleEndAssortment = () => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/${assortmentId}/inactive`,
      "PUT",
      undefined,
      (response) => {
        toastr.success("Assortment inactive successfully");
        setLoading(false);
        setShowDeleteModal(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error(err.message || "Something went wrong");
        setLoading(false);
        setShowDeleteModal(false);
      }
    );
  };

  const startAutoScroll = (direction) => {
    if (scrollIntervalRef.current) return;
    const scrollStep = direction === 'up' ? -20 : 20;
    scrollIntervalRef.current = setInterval(() => {
      if (itemsContainerRef.current) {
        const currentScroll = itemsContainerRef.current.scrollTop;
        const maxScroll = itemsContainerRef.current.scrollHeight - itemsContainerRef.current.clientHeight;

        // Only scroll if not at the boundary
        if ((direction === 'up' && currentScroll > 0) ||
          (direction === 'down' && currentScroll < maxScroll)) {
          itemsContainerRef.current.scrollBy({
            top: scrollStep,
            behavior: 'smooth'
          });
        } else {
          stopAutoScroll();
        }
      }
    }, 50);
  };

  const stopAutoScroll = () => {
    if (scrollIntervalRef.current) {
      clearInterval(scrollIntervalRef.current);
      scrollIntervalRef.current = null;
    }
    setAutoScrollDirection(null);
  };

  const handleDragUpdate = (e) => {
    if (!itemsContainerRef.current || !e.clientY) {
      stopAutoScroll();
      return;
    }

    const container = itemsContainerRef.current;
    const { top, bottom, height } = container.getBoundingClientRect();
    const clientY = e.clientY;
    const buffer = height * 0.2;

    if (clientY < top + buffer) {
      if (autoScrollDirection !== 'up') {
        stopAutoScroll();
        setAutoScrollDirection('up');
        startAutoScroll('up');
      }
    } else if (clientY > bottom - buffer) {
      if (autoScrollDirection !== 'down') {
        stopAutoScroll();
        setAutoScrollDirection('down');
        startAutoScroll('down');
      }
    } else {
      stopAutoScroll();
    }
  };
  console.log("slot details", assortmentSlotDetails)
  return (
    <WarehouseAssortmentDetailsComponent
      assortmentDetails={assortmentDetails}
      loading={loading}
      activeTabIndex={activeTabIndex}
      onTabChange={handleTabChange}
      itemsContainerRef={itemsContainerRef}
      autoScrollDirection={autoScrollDirection}
      hasChanges={hasChanges}
      onSaveChanges={handleSaveChanges}
      onCancelChanges={handleCancelChanges}
      handleEndAssortment={handleEndAssortment}
      setShowDeleteModal={setShowDeleteModal}
      showDeleteModal={showDeleteModal}
      categories={categories}
      selectedCategory={selectedCategory}
      onCategoryChange={setSelectedCategory}
      currentItems={getCurrentItems()}
      remainingItems={getRemainingItems()}
      onItemDrop={handleItemDrop}
      onDragUpdate={handleDragUpdate}
      getSlotDetailsForItem={getSlotDetailsForItem}
      assortmentSlotDetails={assortmentSlotDetails}
      handleCheckRule={handleCheckRule}
      
    />
  );
};

export default connect(null, { getDataFromAPI })(CohortAssortmentDetailsContainer);